// @ts-nocheck
import dayjs from "dayjs";

export function getTimeDifference(time1, time2) {
  const minutes1 = convertToMinutes(time1);
  const minutes2 = convertToMinutes(time2);

  let differenceMinutes = Math.abs(minutes2 - minutes1);

  let differenceHours = Math.floor(differenceMinutes / 60);
  let remainingMinutes = differenceMinutes % 60;

  // return {
  //   hours: differenceHours,
  //   minutes: remainingMinutes,
  // };
  return differenceHours;
}

function convertToMinutes(time) {
  const [hour, minute, period] = time.split(/:| /);
  let totalMinutes = parseInt(hour) * 60 + parseInt(minute);

  if (period.toLowerCase() === "pm") {
    totalMinutes += 12 * 60;
  }

  return totalMinutes;
}

export function getUTCTimeDifference(time1, time2) {
  const h1 = new Date(time1).getHours();
  const m1 = new Date(time1).getMinutes() / 100;
  const h2 = new Date(time2).getHours();
  const m2 = new Date(time2).getMinutes() / 100;
  const val1 = h1 + m1;
  const val2 = h2 + m2;

  // const diff = Math.ceil(val2 - val1);
  const diff = val2 - val1;
  return diff;
}

export function getUTCTimeDifferenceWithDate(utcDate1, utcDate2) {
  try {
    // Parse the UTC dates
    const date1 = Date.parse(utcDate1);
    const date2 = Date.parse(utcDate2);

    // Check if parsing was successful
    if (isNaN(date1) || isNaN(date2)) {
      throw new Error("Invalid date format");
    }

    // Calculate the difference in milliseconds
    let difference = date2 - date1;

    // Handle cases where dates span across different days
    const dayInMilliseconds = 24 * 60 * 60 * 1000;
    if (difference < 0) {
      // Add a day if date2 is earlier than date1
      difference += dayInMilliseconds;
    }

    // Get the absolute value of the time difference
    const absoluteDifference = Math.abs(difference);

    // Convert milliseconds to hours and round up
    // const hoursDifference = Math.ceil(absoluteDifference / (1000 * 60 * 60));
    const hoursDifference = absoluteDifference / (1000 * 60 * 60);

    return hoursDifference.toFixed(2);
  } catch (error) {
    return null; // Return null in case of error
  }
}

/**
 * calculate age
 * @param dayjs.Dayjs dob
 * @returns age
 */
export function calculateAge(dob) {
  if (!dob) return null;

  const birthDate = dayjs(dob);
  const today = dayjs();

  const age = today.diff(birthDate, "year");

  return age?.toString();
}